// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"styles_tableWrapper__3B4ek","dataValue":"styles_dataValue__2W07v"};